// components/MetaverseLoader.js
import React from 'react';
import { Box, Typography } from '@mui/material';

const MetaverseLoader = ({ message = "Zolang Nexora Softwares..." }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '400px',
        background: 'linear-gradient(135deg, #0a1128 0%, #1a1f3d 100%)',
        borderRadius: 3,
        p: 4,
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      {/* Animated Orbital System */}
      <Box
        sx={{
          position: 'relative',
          width: 120,
          height: 120,
          mb: 3,
        }}
      >
        {/* Central Core */}
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 20,
            height: 20,
            background: 'linear-gradient(45deg, #8b0000, #ff4d4d)',
            borderRadius: '50%',
            boxShadow: '0 0 20px rgba(139, 0, 0, 0.5)',
            animation: 'pulse 2s infinite ease-in-out',
          }}
        />
        
        {/* Orbital Rings */}
        {[0, 1, 2].map((ring) => (
          <Box
            key={ring}
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: `${40 + ring * 30}px`,
              height: `${40 + ring * 30}px`,
              border: `1px solid rgba(139, 0, 0, ${0.3 - ring * 0.1})`,
              borderRadius: '50%',
              animation: `rotate ${3 + ring * 2}s linear infinite`,
            }}
          />
        ))}
        
        {/* Orbiting Particles */}
        {[0, 45, 90, 135, 180, 225, 270, 315].map((angle, index) => (
          <Box
            key={index}
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              width: 6,
              height: 6,
              background: `linear-gradient(45deg, #8b0000, #${['b30000', 'cc0000', 'e60000'][index % 3]})`,
              borderRadius: '50%',
              transform: `rotate(${angle}deg) translate(35px) rotate(-${angle}deg)`,
              animation: `orbit ${4 + (index % 3)}s linear infinite`,
              boxShadow: '0 0 10px rgba(139, 0, 0, 0.7)',
            }}
          />
        ))}
      </Box>

      {/* Loading Text */}
      <Typography
        variant="h6"
        sx={{
          color: '#8b0000',
          fontWeight: 'bold',
          textAlign: 'center',
          background: 'linear-gradient(45deg, #8b0000, #ff4d4d)',
          backgroundClip: 'text',
          WebkitBackgroundClip: 'text',
          color: 'transparent',
          mb: 2,
        }}
      >
        {message}
      </Typography>

      {/* Animated Dots */}
      <Box sx={{ display: 'flex', gap: 1 }}>
        {[0, 1, 2].map((dot) => (
          <Box
            key={dot}
            sx={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              background: `linear-gradient(45deg, #8b0000, #${['b30000', 'cc0000', 'e60000'][dot]})`,
              animation: `bounce 1.4s infinite ease-in-out`,
              animationDelay: `${dot * 0.16}s`,
            }}
          />
        ))}
      </Box>

      {/* Additional CSS for animations */}
      <style jsx>{`
        @keyframes rotate {
          from { transform: translate(-50%, -50%) rotate(0deg); }
          to { transform: translate(-50%, -50%) rotate(360deg); }
        }
        
        @keyframes orbit {
          from { transform: rotate(0deg) translate(35px) rotate(0deg); }
          to { transform: rotate(360deg) translate(35px) rotate(-360deg); }
        }
        
        @keyframes bounce {
          0%, 80%, 100% {
            transform: scale(0.8);
            opacity: 0.5;
          }
          40% {
            transform: scale(1.2);
            opacity: 1;
          }
        }
      `}</style>
    </Box>
  );
};

export default MetaverseLoader;